// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_jn-0";